import React from 'react';
import { Animator } from 'wix-animations';
import PropTypes from 'prop-types';
import { dataHooks, skins } from '../constants';
import { st, classes } from './AccordionStripItem.st.css';
import { MainItemContainer, Header, ItemNumber, ItemTitle } from '../style';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

class AccordionStripItem extends React.PureComponent {
  static displayName = 'AccordionStripItem';

  static propTypes = {
    title: PropTypes.node,
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    initiallyOpen: PropTypes.bool,
    onToggle: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    skin: PropTypes.oneOf([skins.loose, skins.tight]),
    className: PropTypes.string,
  };

  state = {
    hover: false,
  };

  _onMouseLeave = (e) => {
    const { onMouseLeave } = this.props;

    this.setState({ hover: false });
    onMouseLeave && onMouseLeave(e);
  };
  _onMouseEnter = (e) => {
    const { onMouseEnter } = this.props;

    this.setState({ hover: true });
    onMouseEnter && onMouseEnter(e);
  };
  _renderOpenButton = () => {
    return <></>;
  };

  _renderCloseButton = () => {
    return <></>;
  };

  render() {
    const {
      title,
      isOpen,
      children,
      onToggle,
      skin,
      className,
      isFirst,
      isLast,
      itemIndex,
      design,
      styleParams,
      settings,
    } = this.props;
    const { hover } = this.state;
    const firstClass = isFirst ? classes.first : '';
    const lastClass = isLast ? classes.last : '';
    const openClass = isOpen ? classes.isOpen : '';
    const alignmentClass = classes['alignment-' + settings.textAlignment];
    const itemMainDivClass = st(
      classes.root,
      { hover, skin },
      className,
      firstClass,
      lastClass,
      openClass,
      alignmentClass,
    );
    return (
      <MainItemContainer
        role="listitem"
        className={itemMainDivClass}
        data-hook={dataHooks.item}
        design={design}
        styleParams={styleParams}
      >
        <Header
          role="button"
          tabIndex="0"
          aria-expanded={isOpen}
          design={design}
          styleParams={styleParams}
          onClick={onToggle}
          className={classes.header}
          data-hook="header"
          onKeyPress={onToggle}
          onMouseEnter={this._onMouseEnter}
          onMouseLeave={this._onMouseLeave}
        >
          <ItemNumber
            design={design}
            styleParams={styleParams}
            className={st(classes.number)}
            settings={settings}
          >
            <div>{String(itemIndex).padStart(2, '0')}</div>
          </ItemNumber>
          <ItemTitle
            className={classes.title}
            design={design}
            styleParams={styleParams}
            data-hook="titleContainer"
            settings={settings}
          >
            {title}
          </ItemTitle>

          <div
            className={classes.toggleButton}
            data-hook="toggle-accordion-wrapper"
            children={
              isOpen ? this._renderCloseButton() : this._renderOpenButton()
            }
          />
        </Header>
        {settings.enableScrollAnimation ? (
          <Animator show={isOpen} height>
            <div data-hook="children" className={classes.children}>
              {children}
            </div>
          </Animator>
        ) : (
          <div
            data-hook="children"
            className={classes.children}
            style={{ display: isOpen ? 'block' : 'none' }}
          >
            {children}
          </div>
        )}
      </MainItemContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(AccordionStripItem));
